import { Typography } from '@mui/material';

import { useAuth } from 'modules/auth/hooks/useAuth';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { referralGreetingTranslation } from './translation';

export const ReferralGreeting = () => {
  const { isLoggedIn } = useAuth();

  const {
    keys: { loggedIn, loggedOut },
    t,
  } = useTranslation(referralGreetingTranslation);

  const keys = isLoggedIn ? loggedIn : loggedOut;

  return (
    <>
      <Typography variant="h6" sx={{ letterSpacing: '-0.03em' }}>
        {t(keys.title)}
      </Typography>
      <Typography variant="body2">{t(keys.description)}</Typography>
      <Typography variant="body2">{t(keys.invitationToSignIn)}</Typography>
    </>
  );
};
